import type { Report } from '../reports/types';
import { PaymentsSection } from './PaymentsSection';
import { ReportHistory } from './ReportHistory';

/** What release 2's closing adds under a report's totals: its payments and its «Storia». */
export function ReportClosingParts({
  report,
  adopt,
}: {
  readonly report: Report;
  readonly adopt: (report: Report) => void;
}) {
  return (
    <>
      <PaymentsSection report={report} adopt={adopt} />
      <ReportHistory reportId={report.id} revision={`${report.version}:${report.reimbursed}`} />
    </>
  );
}
